







import { Component, Vue } from 'vue-property-decorator';
import {DelayLoading} from '@/utlitities/delay-loading';

@Component({
  components: {
  },
})
export default class ReloadLoading extends Vue {
  visible: boolean = false;

  private t: any;

  mounted(){
    if(this.t){
      clearTimeout(this.t);
    }

    this.t = setTimeout(()=>{
      this.visible = true;
      clearTimeout(this.t);
    },1000);
  }

  beforeDestroy(){
    if(this.t){
      clearTimeout(this.t);
    }
  }

}
